import {
  ListViewResultDescription,
  ListViewResultIcon,
  ListViewResultMeta,
  ListViewResultRow,
  ListViewResultSection,
  ListViewResultTitle,
  SearchResultItem,
  StyledSearchResultsItemTitle,
} from "../searchResults";
import { formatSearchResultTitle } from "../../util/stringUtil";
import { useActions } from "../../hooks/useActions";
import useSearchParams from "../../hooks/useSearchParams";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import useMobileScreen from "../../hooks/useMobileScreen";
import { breakpoints } from "../../constants";

type Props = {
  key: number | string;
  title: string;
  lat: number | string;
  lon: number | string;
  hashId: string | number;
  imgSrc: string;
  paragraphs: string[];
};

const GeneralSearchResultItem = ({
  key,
  title,
  lat,
  lon,
  hashId,
  imgSrc,
  paragraphs,
}: Props) => {
  const { setCurrentMarker } = useActions();
  const { setSearchParam } = useSearchParams();
  const isListViewActive = useTypedSelector(
    (state) => state.mapInterface.isListViewActive
  );
  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderListView = isListViewActive && !isMobile;

  const handleClickSearchResult = () => {
    setSearchParam("hash_id", hashId);
  };

  const [primaryParagraph, ...restParagraphs] = paragraphs;
  const additionalParagraphs = restParagraphs.filter((paragraph) => paragraph);

  return (
    <SearchResultItem
      hashId={hashId}
      key={key}
      onMouseEnter={() => {
        setCurrentMarker({ lon: +lon, lat: +lat });
      }}
      onMouseLeave={() => setCurrentMarker({ lon: 0, lat: 0 })}
      onClick={handleClickSearchResult}
    >
      {shouldRenderListView ? (
        <ListViewResultRow>
          <ListViewResultIcon>
            <img src={imgSrc} alt="" width={40} height={40} />
          </ListViewResultIcon>
          <ListViewResultSection flex="2 1 320px">
            <ListViewResultTitle>
              {formatSearchResultTitle(title)}
            </ListViewResultTitle>
            {primaryParagraph && (
              <ListViewResultMeta>{primaryParagraph}</ListViewResultMeta>
            )}
          </ListViewResultSection>
          {additionalParagraphs.map((subtitle, index) => (
            <ListViewResultSection key={index} flex="1 1 220px">
              <ListViewResultDescription>{subtitle}</ListViewResultDescription>
            </ListViewResultSection>
          ))}
        </ListViewResultRow>
      ) : (
        <>
          <img src={imgSrc} alt="" width={40} height={40} />
          <StyledSearchResultsItemTitle>
            {formatSearchResultTitle(title)}
          </StyledSearchResultsItemTitle>
          {paragraphs.map((subtitle, index) => (
            <p key={index}>{subtitle}</p>
          ))}
        </>
      )}
    </SearchResultItem>
  );
};

export default GeneralSearchResultItem;
